import React from 'react';
import PropTypes from 'prop-types';

const DivButton = props => {
  const { children, ...rest } = props;
  return <div {...rest}>{children}</div>;
};

DivButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default DivButton;
